<a target="blank" [href]="helpCentreAddress"><fa-icon [icon]="faInfoCircle" class="help-centre-link-icon"></fa-icon></a>